import { HelmetDexteel } from "@dexteel/mesf-core";
import { StraightenerRecipesManager } from "./components/StraightenerRecipesManager";

export const StraightenerRecipesPage = () => {
	return (
		<>
			<HelmetDexteel title="Straightener Recipes" />
			<StraightenerRecipesManager />
		</>
	);
};
